<div fxLayout="row wrap">
    <div fxLayout="column" fxFlex="30" fxFlex.lt-md="100" fxFlex.md="48" class="form-block">
        <h3>{{'admin-center.header.userData' | translate}}</h3>
        <span *ngIf="!userProfile">{{'validations.errorWhenLoadingData' | translate}}</span>
        <div>
            <form *ngIf="!!userProfile" [formGroup]="editDataForm">
                <div fxLayout="column">

                    <app-user-form [form]="editDataForm"></app-user-form>

                    <div fxLayoutAlign="end end">
                        <button type="button" kendoButton (click)="update()" [primary]="true"> {{'global.update' |
                            translate}}</button>
                    </div>
                </div>
            </form>
        </div>
    </div>


    <div  fxLayout="column" fxFlex="30" fxFlex.lt-md="100" fxFlex.md="48" class="form-block">
        <div fxLayout="column">
            <div>
                <h3 fxLayout="row">{{'admin-center.header.rolesAndAbilities' | translate}}</h3>
            </div>
            <div fxLayout="row" fxFlex="70" fxLayoutAlign="end end" fxLayoutGap="5px" *ngIf="isAdmin">
                <button type="button" kendoButton (click)="addRole()" look="outline"
                    icon="plus">{{'admin-center.user.addUserRole'
                    | translate}}</button>

                <button type="button" kendoButton (click)="addAbility()" look="outline"
                    icon="plus">{{'admin-center.user.addUserAbility'
                    | translate}}</button>

                <button type="button" kendoButton (click)="addRestriction()" look="outline"
                    icon="plus">{{'admin-center.user.addUserRestriction'
                    | translate}}</button>
            </div>
        </div>
        <div fxLayout="column" *ngIf="userProfile">
            <div class="form-block">
                <div class="form-block-header" fxLayoutAlign="center center">{{'admin-center.user.roles' | translate}}
                </div>
                <div *ngFor="let userRole of userProfile.userRoles">
                    <kendo-icon  *ngIf="userRole.id !== superAdminRoleId && isAdmin" [name]="'delete'"
                        (click)="removeRole(userRole.id)"></kendo-icon>
                    {{userRole.description | translate}}
                </div>
            </div>

            <div class="form-block">
                <div class="form-block-header" fxLayoutAlign="center center">{{'admin-center.user.abilities' |
                    translate}}</div>
                <div *ngFor="let userAbility of userProfile.userAbilities">
                    <kendo-icon *ngIf="isAdmin" [name]="'delete'" (click)="removeAbility(userAbility.id)"></kendo-icon>
                    {{userAbility.description | translate}}
                </div>
            </div>

            <div class="form-block">
                <div class="form-block-header" fxLayoutAlign="center center">{{'admin-center.user.restrictions' |
                    translate}}</div>
                <div *ngFor="let userRestriction of userProfile.userRestrictions">
                    <kendo-icon *ngIf="isAdmin" [name]="'delete'" (click)="removeRestriction(userRestriction.id)"></kendo-icon>
                    {{userRestriction.description | translate}}
                </div>
            </div>
        </div>
    </div>


    <div fxLayout="column" fxFlex="30" fxFlex.lt-md="100" fxFlex.md="48" class="form-block">
        <h3>{{'admin-center.header.userOperations' | translate}}</h3>
        <div fxLayout="column" *ngIf="userProfile" fxLayoutGap="5px">
            <div>
                <kendo-switch [(ngModel)]="userProfile.portalUser.isEnabled" (valueChange)="setUserEnable($event)" *ngIf="isAdmin">
                </kendo-switch>
                <span *ngIf="userProfile.portalUser.isEnabled">{{'admin-center.user.userActive' | translate}}
                    <kendo-icon [name]="'check-circle'" [themeColor]="'success'"></kendo-icon>
                </span>
                <span *ngIf="!userProfile.portalUser.isEnabled">{{'admin-center.user.userNotActive' | translate}}
                    <kendo-icon [name]="'error'" [themeColor]="'error'"></kendo-icon>
                </span>
            </div>

            <div>
                <kendo-switch [ngModel]="!userProfile.portalUser.isLockedOut"
                    [readonly]="!userProfile.portalUser.isLockedOut" (valueChange)="unlockUser($event)" *ngIf="isAdmin"></kendo-switch>
                <span *ngIf="!userProfile.portalUser.isLockedOut">{{'admin-center.user.userNotLockedOut' | translate}}
                    <kendo-icon [name]="'check-circle'" [themeColor]="'success'"></kendo-icon>
                </span>
                <span *ngIf="userProfile.portalUser.isLockedOut">{{'admin-center.user.userLockedOut' | translate}}
                    {{userProfile.portalUser.lockoutEnd | date:'yyyy-MM-dd HH:mm:ss'}}
                    <kendo-icon [name]="'error'" [themeColor]="'error'"></kendo-icon>
                </span>
            </div>

            <div fxLayout="row">
                <button *ngIf="isAdmin" type="button" kendoButton (click)="sendResetPasswordLink()" [primary]="true">
                    {{'admin-center.user.sendResetPasswordLink' |
                    translate}}</button>
                <div *ngIf="linkSent">
                    <kendo-icon [name]="'check-circle'" [themeColor]="'success'"> </kendo-icon>
                </div>
            </div>

            <div fxLayout="row">
                <button *ngIf="isAdmin" type="button" kendoButton (click)="changePassword()" [primary]="true">
                    {{'admin-center.user.changePassword' | translate}}</button>
            </div>

        </div>
    </div>
</div>

<div kendoDialogContainer #userManageDialog></div>